import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagFRSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={props.size ?? 16} viewBox="0 0 16 16">
      <mask id="icon-flag-fr-small" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
        <rect x="2" y="2" width="12" height="12" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#icon-flag-fr-small)">
        <path fill="#000091" d="M0 0h5v16H0z" />
        <path fill="#fff" d="M5 0h6v16H5z" />
        <path fill="#E1000F" d="M11 0h5v16h-5z" />
        <rect x="2.5" y="2.5" width="11" height="11" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
